module.exports = __webpack_public_path__ + "img/kisters-logo.30f580ac.png";